import { useCallback, useEffect, useState } from "react";
import { api, formatError } from "../../lib/api";
import { toast } from "sonner";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Textarea } from "../../components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";

const TYPES = ["planting", "irrigation", "harvest", "pest_control", "fertilizing", "inspection"];

export default function LogActivityPage() {
  const [plots, setPlots] = useState([]);
  const [form, setForm] = useState({ plot_id: "", activity_type: "", title: "", description: "" });
  const [busy, setBusy] = useState(false);

  const loadPlots = useCallback(async () => {
    const r = await api.get("/plots");
    setPlots(r.data);
  }, []);
  useEffect(() => { loadPlots(); }, [loadPlots]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/activities", form);
      toast.success("Activity logged");
      setForm({ plot_id: "", activity_type: "", title: "", description: "" });
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <div className="p-6 md:p-10 max-w-lg pb-24">
      <h1 className="heading text-3xl md:text-4xl">Log activity</h1>
      <p className="text-sm text-muted-foreground mt-1 mb-6">Record work completed on a plot.</p>
      <form onSubmit={submit} className="space-y-4" data-testid="log-activity-form">
        <div>
          <Label>Plot</Label>
          <Select value={form.plot_id} onValueChange={(v) => setForm({ ...form, plot_id: v })}>
            <SelectTrigger data-testid="log-plot-select"><SelectValue placeholder="Select plot" /></SelectTrigger>
            <SelectContent>{plots.map((p) => (<SelectItem key={p.id} value={p.id}>Plot {p.plot_number}</SelectItem>))}</SelectContent>
          </Select>
        </div>
        <div>
          <Label>Type</Label>
          <Select value={form.activity_type} onValueChange={(v) => setForm({ ...form, activity_type: v })}>
            <SelectTrigger data-testid="log-type-select"><SelectValue placeholder="Select type" /></SelectTrigger>
            <SelectContent>{TYPES.map((t) => (<SelectItem key={t} value={t}>{t.replace("_", " ")}</SelectItem>))}</SelectContent>
          </Select>
        </div>
        <div>
          <Label>Title</Label>
          <Input required value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} data-testid="log-title-input" />
        </div>
        <div>
          <Label>Description</Label>
          <Textarea rows={3} value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} data-testid="log-desc-input" />
        </div>
        <Button className="w-full" disabled={busy || !form.plot_id || !form.activity_type || !form.title} data-testid="log-submit-btn">
          {busy ? "Logging…" : "Log activity"}
        </Button>
      </form>
    </div>
  );
}
